import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */
const tag = '[VOLATILE_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  startupComplete: null,
  changeLanguage: null
};

const { Types, Creators } = createActions(functionDefinitions);

export const VolatileTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const VolatileInitState = {
  startupComplete: false,
  changeLanguageComplete: false
}; 

export const INITIAL_STATE = Immutable(VolatileInitState);

/* ------------- Reducers ------------- */

export const startupComplete = state => {
  console.log(`${tag} Startup complete..`);
  return state.merge({ startupComplete: true });
};

export const changeLanguageComplete = state => {
  console.log(`${tag} ChangeLanguage complete..`);
  return state.merge({ changeLanguageComplete: true });
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.STARTUP_COMPLETE]: startupComplete,
  [Types.CHANGE_LANGUAGE]: changeLanguageComplete
});



// WEBPACK FOOTER //
// ./src/redux/volatile/volatileRedux.ts